import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



import { HboComponent } from './hbo/hbo.component';

@NgModule({
  declarations: [
    AppComponent,
    HboComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ToastrModule.forRoot({
        progressBar:true, 
        timeOut: 5000,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
    }),
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts